import Seed from "./Seed";
export default Seed;
